import { createTheme as createMaterialTheme } from '@mui/material/styles'
import { createAppTheme } from './theme'

export function createMuiTheme(mode = 'light') {
  const appTheme = createAppTheme(mode)

  return createMaterialTheme({
    palette: {
      mode,
      primary: {
        main: appTheme.colors.muiPrimary,
        contrastText: mode === 'dark' ? appTheme.colors.primaryFill : appTheme.colors.onPrimary,
      },
      secondary: {
        main: appTheme.colors.secondary,
      },
      background: {
        default: appTheme.colors.background,
        paper: appTheme.colors.surface,
      },
      text: {
        primary: appTheme.colors.text,
        secondary: appTheme.colors.textMuted,
      },
      divider: appTheme.colors.border,
      action: {
        hover: appTheme.colors.primarySoft,
        selected: appTheme.colors.primarySoft,
        disabled: appTheme.colors.gray,
        disabledBackground: appTheme.colors.lightestGray,
      },
    },
    shape: {
      borderRadius: 10,
    },
    typography: {
      fontFamily: "'Pretendard Variable', 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      button: {
        fontWeight: 650,
        textTransform: 'none',
      },
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            // MUI adds a pale elevation overlay in dark mode by default.
            // Keeping one opaque surface color prevents raised panels from
            // looking like their light-mode colors were inverted.
            backgroundImage: 'none',
            borderColor: appTheme.colors.border,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            minHeight: 40,
            boxShadow: 'none',
            borderRadius: 10,
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            backgroundColor: appTheme.colors.surface,
            color: appTheme.colors.text,
            '&.Mui-focused': {
              boxShadow: `0 0 0 3px ${appTheme.colors.focusSoft}`,
            },
          },
        },
      },
      MuiInputAdornment: {
        styleOverrides: {
          root: {
            '& .MuiIconButton-root': {
              color: appTheme.colors.muiPrimary,
            },
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          icon: {
            color: appTheme.colors.muiPrimary,
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              color: mode === 'dark' ? appTheme.colors.text : appTheme.colors.primary,
              backgroundColor: appTheme.colors.primarySoft,
            },
            '&.Mui-selected:hover': {
              backgroundColor: appTheme.colors.primarySoft,
            },
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              color: mode === 'dark' ? appTheme.colors.primaryFill : appTheme.colors.onPrimary,
              backgroundColor: appTheme.colors.muiPrimary,
            },
            '&.MuiPickersDay-today': {
              borderColor: appTheme.colors.muiPrimary,
            },
          },
        },
      },
      MuiPickersYear: {
        styleOverrides: {
          yearButton: {
            '&.Mui-selected': {
              color: mode === 'dark' ? appTheme.colors.primaryFill : appTheme.colors.onPrimary,
              backgroundColor: appTheme.colors.muiPrimary,
            },
          },
        },
      },
      MuiClockNumber: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              color: mode === 'dark' ? appTheme.colors.primaryFill : appTheme.colors.onPrimary,
              backgroundColor: appTheme.colors.muiPrimary,
            },
          },
        },
      },
      MuiMultiSectionDigitalClockSection: {
        styleOverrides: {
          item: {
            '&.Mui-selected': {
              color: mode === 'dark' ? appTheme.colors.primaryFill : appTheme.colors.onPrimary,
              backgroundColor: appTheme.colors.muiPrimary,
            },
          },
        },
      },
      MuiPaginationItem: {
        styleOverrides: {
          root: {
            fontWeight: 600,
          },
        },
      },
    },
  })
}
